export default {"src":"/_next/static/media/bell-w.1a38546d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};